module.exports = "/lucky-balls/img/drum/drum_loop_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_002.png
// module id = 1017
// module chunks = 0